module.exports = {
  __depends__: [ require('../../features/touch') ]
};